import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class ParallaxImage {
    constructor(element) {
        this.element = element;
        this.images = element.querySelectorAll("[data-parallax]");
        if (!this.images.length) return;
        this.init();
    }

    init() {
        this.images.forEach(container => {
            const img = container.querySelector("img");
            if (!img) return;

            gsap.set(img, { scale: 1.2, transformOrigin: "center center" });

            gsap.to(img, {
                yPercent: -15,
                ease: "none",
                scrollTrigger: {
                    trigger: container,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                }
            });
        });
    }
}